import { getWeather } from '../../../api/api'
import { logBreadcrumb, logException, logWarning } from '../../../sentry'
import { isTimestampFresh } from '../../../lib/utils'
import { selectUserDefaultWeatherLocationId } from '../../../selectors/userSelector'

export const FETCH_CURRENT_WEATHER = 'FETCH_CURRENT_WEATHER'
export const FETCH_CURRENT_WEATHER_FAILURE = 'FETCH_CURRENT_WEATHER_FAILURE'
export const FETCH_CURRENT_WEATHER_SUCCESS = 'FETCH_CURRENT_WEATHER_SUCCESS'


/**
 * Fetch weather for menubar widget. Fetches and stores minimal amount of data.
 */
export function fetchCurrentWeather(maxStaleSecs = 0) {
  return (dispatch, getState) => {
    const state = getState()
    const locationId = selectUserDefaultWeatherLocationId(state)
    const lastFetchLocationId = state.currentWeather.get('locationId')
    const lastFetchTimestamp = state.currentWeather.get('timestamp')
    const loading = state.currentWeather.get('loading')
    if (lastFetchLocationId === locationId && (isTimestampFresh(lastFetchTimestamp, maxStaleSecs) || loading)) {
      return
    }

    dispatch({
      type: FETCH_CURRENT_WEATHER,
    })

    const params = { id: locationId, hours: 1 }
    return getWeather(params).then(response => {
      // response.data.length should never be missing but sometimes is. Figure out why, fix API and remove null safety.
      if (!response?.data?.length) {
        logBreadcrumb('Current weather response', response)
        throw new TypeError('Invalid data length for current weather')
      }

      // Based on old code it looks like first day's forecasts array could be empty in some cases..?
      // If we can rule this out, remove the check from FETCH_CURRENT_WEATHER_SUCCESS in reducer as well.
      const days = response.data
      if (days[0].forecasts.length === 0) {
        logBreadcrumb('Current weather response', response)
        logWarning('First day forecast empty for current weather')
      }

      dispatch({
        type: FETCH_CURRENT_WEATHER_SUCCESS,
        response,
        timestamp: Date.now(),
      })
    }).catch(error => {
      logException(error)
      dispatch({
        type: FETCH_CURRENT_WEATHER_FAILURE,
        timestamp: Date.now(),
        error,
      })
    })
  }
}
